import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Clock, ArrowRight } from "lucide-react";
import { Logo, GoldButton } from "@/components/site/ui";
import { api, inr } from "@/lib/api";

export default function ThankYou() {
    const { orderId } = useParams();
    const nav = useNavigate();
    const [order, setOrder] = useState(null);
    useEffect(() => { api.get(`/orders/track/${orderId}`).then(({ data }) => setOrder(data)).catch(() => {}); }, [orderId]);
    const paid = order?.payment_status === "Paid";

    return (
        <div className="min-h-screen bg-gradient-to-b from-teal-950 via-teal-900 to-teal-800 text-cream grain">
            <header className="py-4 border-b border-brandborder/60"><div className="container-x"><Logo /></div></header>
            <div className="container-x py-16 max-w-2xl mx-auto text-center">
                <div className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center ${paid ? "bg-growth/15" : "bg-gold/15"}`}>
                    {paid ? <CheckCircle2 className="w-11 h-11 text-growth" /> : <Clock className="w-11 h-11 text-gold" />}
                </div>
                <h1 className="font-serif text-4xl mt-6">Thank You! Your request has been received.</h1>
                <p className="text-cream-soft mt-4 text-lg">Our Business Development Executive will contact you shortly to understand your requirements and plan the next steps.</p>

                {order && (
                    <div className="card-teal rounded-2xl p-6 mt-8 text-left" data-testid="thankyou-summary">
                        <div className="grid grid-cols-2 gap-4 text-sm">
                            <Info label="Order ID" value={<span className="font-mono">{order.order_id}</span>} />
                            <Info label="Amount" value={<span className="font-mono">{inr(order.amount)}</span>} />
                            <Info label="Service / Package" value={[order.package, order.service].filter(Boolean).join(", ") || "—"} />
                            <Info label="Payment Status" value={<span className={paid ? "text-growth font-semibold" : "text-gold font-semibold"}>{order.payment_status}</span>} />
                        </div>
                    </div>
                )}
                <div className="flex flex-wrap justify-center gap-3 mt-8">
                    <GoldButton onClick={() => nav(`/track/${orderId}`)} data-testid="track-request-btn">Track My Request <ArrowRight className="w-4 h-4" /></GoldButton>
                    <button onClick={() => nav("/")} className="btn-ghost-cream rounded-full px-6 py-3">Back to Home</button>
                </div>
            </div>
        </div>
    );
}

function Info({ label, value }) { return <div><div className="text-cream-soft/60 text-xs uppercase">{label}</div><div className="mt-1 text-cream">{value}</div></div>; }
